import { useQuery } from '@tanstack/react-query';
import { CateringData, CateringMetadata } from 'types/catering';
import { apiRequest } from 'helpers/api';
import { CUBOH_COMPANY_PREFIX } from 'constants/path';

interface CateringResponse {
  data: CateringData;
  metadata: CateringMetadata;
}

export const CATERING_SETTINGS_QUERY_KEY = 'cateringSettings';

export function useGetCateringSettings(restaurantId: string | undefined, enabled: boolean = false) {
  const query = useQuery<CateringResponse>({
    queryKey: [CATERING_SETTINGS_QUERY_KEY, restaurantId],
    queryFn: async () => {
      const { data, error } = await apiRequest<CateringResponse>({
        path: `restaurant/${restaurantId}/catering`,
        customHost: import.meta.env.VITE_ADMIN_API_HOST,
      });
      if (error) throw error;
      if (!data) throw new Error('No catering settings data returned');
      return data;
    },
    enabled: Boolean(restaurantId) && enabled && !restaurantId?.includes(CUBOH_COMPANY_PREFIX),
  });

  return {
    cateringData: query.data?.data ?? null,
    metadata: query.data?.metadata ?? null,
    isCateringLoading: query.isLoading,
    hasError: query.isError,
    refetch: () => {
      void query.refetch();
    },
  };
}
